var styles = {"wrapper":"HTLeNI1dHkw-","DataTable":"RSD-fmW5tBs-","thead":"Tfp3E5H0kys-","heading":"_1rjFYQERgMM-","headingLabel":"c7Tce3P-ZPE-","sortable":"_804fMFZzvPA-","cell":"P0mF0JNmERk-","cellContent":"PpmgMeYkUcM-"};

export { styles as default };
//# sourceMappingURL=DataTablePrototype.module.css.js.map
